// extracted by mini-css-extract-plugin
export var actionText = "_n0-4";
export var container = "_n0-0";
export var leftSection = "_n0-1";
export var rightSection = "_n0-2";
export var settingsButton = "_n0-6";
export var settingsIcon = "_n0-7";
export var shortcut = "_n0-5";
export var shortcutGroup = "_n0-3";